<template>
  <v-data-table
    :headers="headers"
    :items="pasajes"
    :disable-pagination="true"
    class="mx-16"
    hide-default-footer
  >
    <template #item.pas_aereo="{ item }">
      {{ new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2 }).format(item.pas_aereo) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="text-truncate">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              icon
              class="mr-2"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="$emit('liberar', item)"
            >
              <v-icon>airplane_ticket</v-icon>
            </v-btn>
          </template>
          <span>Liberar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              icon
              class="mr-2"
              color="error"
              v-bind="attrs"
              v-on="on"
              @click="$emit('anular', item)"
            >
              <v-icon>no_sim</v-icon>
            </v-btn>
          </template>
          <span>Anular</span>
        </v-tooltip>
      </div>
    </template>
    <template v-slot:no-data>
      <h6>No se encuentra en presupuesto</h6>
    </template>
    <template v-slot:body.append>
      <tr>
        <td class="text-right" colspan="2">Total:</td>
        <td class="text-right">
          {{ new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2 }).format(sumField('pas_aereo', pasajes)) }}
        </td>
        <td></td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: 'PasajeTable',
  props: {
    headers: { type: Array, default: () => [] },
    pasajes: { type: Array, default: () => [] }
  },
  methods: {
    sumField(key, pasajes) {
      return pasajes.reduce((a, b) => a + (b[key] || 0), 0);
    }
  }
};
</script> 